import {useSelector} from 'react-redux'

import {selectUser} from 'features/User'
import {useAllowedDomainsCheck} from './useAllowedDomainsCheck'
import {DOPE_PRIMARY_DOMAIN} from 'definitions/constant'

interface useFeatureFlagReturnType {
  isDopeTenant: boolean
  isPaywalled: boolean
  developmentOnlyFeatureFlag: boolean
  stagingOnlyFeatureFlag: boolean
  nonProductionFeatureFlag: boolean
  dopeInternalFeatureFlag: boolean
  productionDopeFeatureFlag: boolean
}

enum Environment {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  TEST = 'test',
}

/**
 * @description This hook is used to get the feature flag values
 */
export const useFeatureFlag = (): useFeatureFlagReturnType => {
  const user = useSelector(selectUser)
  const {isPaywalled} = useAllowedDomainsCheck()

  const primaryDomain = user?.primaryDomain

  /**
   * Default global feature flags for the application.
   */
  const isDopeTenant = primaryDomain === DOPE_PRIMARY_DOMAIN

  const developmentOnlyFeatureFlag =
    process.env.REACT_APP_ENV === Environment.DEVELOPMENT

  const stagingOnlyFeatureFlag =
    process.env.REACT_APP_ENV === Environment.STAGING

  const nonProductionFeatureFlag =
    process.env.REACT_APP_ENV !== Environment.PRODUCTION

  // true if the environment is not production and primaryDomain is dope.security
  const dopeInternalFeatureFlag = nonProductionFeatureFlag && isDopeTenant

  // true if the environment is production and primaryDomain is dope.security
  const productionDopeFeatureFlag = !nonProductionFeatureFlag && isDopeTenant

  /**
   * Individual feature flags for different features on the platform.
   */

  return {
    nonProductionFeatureFlag,
    isDopeTenant,
    developmentOnlyFeatureFlag,
    stagingOnlyFeatureFlag,
    dopeInternalFeatureFlag,
    productionDopeFeatureFlag,
    isPaywalled,
  }
}
